import { SxProps } from '@mui/material'
import { COLORS } from '@/styles'
import { swiperClasses } from '../Swiper.data'
import { imageSliderClasses } from './ImageSlider.data'

interface ImageSliderTypes {
  imageSwiperWrapper: SxProps
  imageStyles: SxProps
  wrapper: SxProps
  swiperWrapper: SxProps
  thumbnailWrapper: SxProps
  thumbnailCountWrapper: SxProps
  thumbnailCountText: SxProps
  thumbnailImageWrapper: SxProps
}

const imageSliderDimensions = {
  image: {
    width: 60,
    height: 50,
  },
  buttonSize: 60,
}

export const imageSwiperStyles: ImageSliderTypes = {
  imageSwiperWrapper: {
    width: '100%',
    height: '100%',
    [`.${swiperClasses.swiperButtonNext}, .${swiperClasses.swiperButtonPrev}`]: {
      width: imageSliderDimensions.buttonSize,
      height: imageSliderDimensions.buttonSize,
      color: COLORS.FOREGROUND_DISABLED,
      backgroundColor: 'transparent',
      border: 0,
      borderRadius: '50%',
      boxShadow: 'none',
      margin: 0,
      top: `calc(50% - ${imageSliderDimensions.buttonSize / 2}px)`,
      userSelect: 'none',
    },
    [`.${swiperClasses.swiperButtonNext}`]: {
      right: 0,
    },
    [`.${swiperClasses.swiperButtonPrev}`]: {
      left: 0,
    },
    [`.${swiperClasses.swiperButtonNext}::after, .${swiperClasses.swiperButtonPrev}::after`]: {
      typography: 'textXsSemibold',
    },
    [`.${swiperClasses.swiperButtonNext}::before, .${swiperClasses.swiperButtonPrev}::before`]: {
      content: '" "',
      width: 28,
      height: 28,
      position: 'absolute',
      top: 'calc(50% - 14px)',
      backgroundColor: 'background.default',
      borderRadius: '50%',
      zIndex: -1,
      boxShadow: '0 1px 4px rgba(0, 0, 0, 0.2)',
      border: '1px solid #D5D7DA',
    },
  },
  imageStyles: {
    [`.${swiperClasses.swiperImage}`]: {
      width: '100%',
      height: '100%',
    },
    [`.${swiperClasses.slide}`]: {
      backgroundSize: 'cover',
    },
    [`.${swiperClasses.slide} img`]: {
      display: 'block',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },
  wrapper: {
    width: '100%',
    height: '100%',
  },
  swiperWrapper: {
    width: '100%',
    height: '100%',
  },
  thumbnailWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: 1,
    [`.${swiperClasses.slide}`]: {
      width: imageSliderDimensions.image.width,
    },
  },
  thumbnailCountWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  thumbnailCountText: {
    typography: 'textXs',
    color: 'text.primary900',
  },
  thumbnailImageWrapper: {
    width: imageSliderDimensions.image.width,
    height: imageSliderDimensions.image.height,

    '&:hover': {
      cursor: 'pointer',
    },

    [`&:not(.${imageSliderClasses.thumb.active})`]: {
      opacity: 0.6,
    },
  },
}
